<template src="./template.html"></template>

<script>
  export default {
    name: 'FooterButton',
    props: {
      requiredFieldsMsg: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      next(e) {
        e.preventDefault()
        this.$emit('next-tab')
        window.scrollTo(0, 0)
      },
    },
  }
</script>
